import styles from './styles.scss';
import { CustomerAddress } from 'models/CustomerAddress';
import cn from 'classnames';
import { rm } from 'utils';

interface OwnProps {
  className?: string;
}

interface MergedProps extends OwnProps {
  address: CustomerAddress;
  header: string;
}

export default function Address({ address, header, className }: MergedProps) {
  return (
    <div className={cn(className, styles.address)}>
      <div className={styles.blueBox}>
        <span className={styles.header}>{header}</span>
        <span>{address.name}</span>
        <br />
        <span>{address.street}</span>
        <br />
        <span>
          {address.zipCode} {address.city}
        </span>
        {address.phone && (
          <span className={styles.phone}>
            {rm('customerpage_order_address_phone')} {address.phone}
          </span>
        )}
      </div>
    </div>
  );
}
